import axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react'
import { Col, FormGroup, Input, Label, Row, Spinner } from 'reactstrap';
import { GetCookieToken } from '../../Cookie/GetCookie';
import { FetchAxiosGet } from '../../../api/axios';
import { CheckSubAdmin } from "../../Function/CheckSubAdmin";
import { CheckPosition } from "../../Function/CheckPosition";
import Select from 'react-select';

function SelectOrg(props) {
    const {setDivisionOrg, setGroupOrg, setUserOrg, arrayOrgGroup = null, task = "nothin", sizeXs = 12, sizeMd = 4, sizeXl = 4, notAdAll = false, functionCheck = undefined, needAlluser = undefined, requiredCondition = true, checkLeave = false} = props
    const [orgInnerKong, setOrgInnerKong] = useState([])
    const [orgInnerGroup, setOrgInnerGroup] = useState([])
    const [orgInnerSubGroup, setOrgInnerSubGroup] = useState([])
    const [orgInnerUser, setOrgInnerUser] = useState([])
    const [mergeArray, setMergeArray] = useState(null)
    const [allGroup, setAllGroup] = useState("")
    const baseURL = process.env.REACT_APP_API_CORS;
    const token = GetCookieToken("userToken");
    const [userInfo, setUserInfo] = useState(null)
    const [closeWordAll, setCloseWordAll] = useState(true)
    const [usersOptions, setUsersOptions] = useState([]);
    const [conditonMessage, setConditonMessage] = useState(false);

    const fetchInfo = async () => {
      const urlInfo = `${baseURL}/api/users/info`;
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      };
      await axios
        .get(urlInfo, config)
        .then((response) => {
          setUserInfo(response?.data?.result)
        })
        .catch((error) => {
          console.error(error);
        });
    };

    const checkPositionForData = (res) =>{
      const check = CheckPosition(userInfo?.position)
      if (check?.includes(3) || check?.includes(4) || check?.includes(5)) {
        let arrayPush = []
        if (check?.includes(3)) {
          if (userInfo?.position?.filter(item=>item.position_id === check?.find(i=>i === 3)).length > 0) {
              userInfo?.position?.filter(item=>item.position_id === check?.find(i=>i === 3)).forEach( async (element) => {
                arrayPush.push(res?.result?.child?.filter(item=>(item.active === 1)).filter(x=> x.org_id === element.org_id))
                await fetchOrgGroup(res?.result?.child?.filter(item=>(item.active === 1)).filter(x=> x.org_id === element.org_id)[0]?.org_id, null, res?.result?.child?.filter(item=>(item.active === 1)).filter(x=> x.org_id === element.org_id))
              });
              arrayPush.flat()
          } else {
            arrayPush.push(res?.result?.child?.filter(item=>(item.active === 1)).filter(x=> x.org_id === userInfo?.position?.find(item=>item.position_id === check?.find(i=>i === 3))?.org_id))
            arrayPush.flat()
          }
        }
        if (check?.includes(4)) {
          if (userInfo?.position?.filter(item=>item.position_id === check?.find(i=>i === 4)).length > 0) {
              userInfo?.position?.filter(item=>item.position_id === check?.find(i=>i === 4)).forEach( async (element) => {
                arrayPush.push(res?.result?.child?.filter(item=>(item.active === 1)).filter(x=> x.org_id === element.org_id))
                await fetchOrgGroup(res?.result?.child?.filter(item=>(item.active === 1)).filter(x=> x.org_id === element.org_id)[0]?.org_id, null, res?.result?.child?.filter(item=>(item.active === 1)).filter(x=> x.org_id === element.org_id))
              });
              arrayPush.flat()
          } else {
            arrayPush.push(res?.result?.child?.filter(item=>(item.active === 1)).filter(x=> x.org_id === userInfo?.position?.find(item=>item.position_id === check?.find(i=>i === 4))?.org_id))
            arrayPush.flat()
          }
        }
        if (check?.includes(5)) {
          if (userInfo?.position?.filter(item=>item.position_id === check?.find(i=>i === 5)).length > 0) {
              userInfo?.position?.filter(item=>item.position_id === check?.find(i=>i === 5)).forEach( async (element) => {
                arrayPush.push(res?.result?.child?.filter(item=>(item.active === 1)).filter(x=> x.org_id === element.org_id))
                await fetchOrgGroup(res?.result?.child?.filter(item=>(item.active === 1)).filter(x=> x.org_id === element.org_id)[0]?.org_id, null, res?.result?.child?.filter(item=>(item.active === 1)).filter(x=> x.org_id === element.org_id))
              });
              arrayPush.flat()
          } else {
            arrayPush.push(res?.result?.child?.filter(item=>(item.active === 1)).filter(x=> x.org_id === userInfo?.position?.find(item=>item.position_id === check?.find(i=>i === 5))?.org_id))
            arrayPush.flat()
          }
        } 
        setOrgInnerKong(arrayPush.flat())
      } else if (check?.includes(7)) {
            if (res?.result?.child?.filter(item=>(item.active === 1)).filter(x=> x.org_id === userInfo?.position?.find(item=>item.position_id === check?.find(i=>i === 7))?.org_id)?.length === 0) {
              let array = []
              res?.result?.child?.filter(item=>(item.active === 1)).map((i,idx)=>{
                if (i?.child?.length > 0) {
                  i?.child?.map(itrms=>{
                    if (userInfo?.position?.filter(item=>item.position_id === check?.find(i=>i === 7)).find(x => x.org_id === itrms.org_id)) {
                      array.push(itrms)
                    }
                  })
                }
              })
              setOrgInnerSubGroup(array)
              if (res?.result?.child
                  ?.filter(item=>(item.active === 1))
                  ?.filter(x=> x.org_id === userInfo?.position
                  ?.find(item=>item.position_id === check
                  ?.find(i=>i === 5))?.org_id)?.length === 0 && array.length > 0) {
                    fetchOrgGroup(null,array)
              }
            }
      }
    }

    const getOrgInnerKong = async () => {
      const res = await FetchAxiosGet("/api/orgInner/level",token)
        if (CheckSubAdmin(userInfo?.positionSubAdmin)) {
          const check = CheckSubAdmin(userInfo?.positionSubAdmin)

          if (check?.includes(0) || check?.includes(2) || check?.includes(1)) {
            let arr = []
            arr.push(
              res?.result?.child
                ?.filter(item=>(item.active === 1 && item.child.length == 0))
                ?.sort((a, b) => {
                const nameA = a.org_name.toLowerCase();
                const nameB = b.org_name.toLowerCase();
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
              }),
              res?.result?.child
                ?.filter(item=>(item.active === 1 && item.child.length > 0))
                ?.sort((a, b) => {
                const nameA = a.org_name.toLowerCase();
                const nameB = b.org_name.toLowerCase();
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
              }))
            setOrgInnerKong(arr.flat());
            await getOrg()
          } else {
            checkPositionForData(res)
          }
        } else if (CheckPosition(userInfo?.position)) {
          checkPositionForData(res)
        }
    };
    

    const getOrg = async () => {
      setConditonMessage(true)
      let options;
      if (!notAdAll) {
        options = [{ value: "", label: 'ทั้งหมด' }]
      } else {
        options = []
      }
      try {
            const params = new URLSearchParams({
            page: 1,
            size: 400,
            "order[0]": "user_id",
            "order[1]": "ASC",
            "filter[user_name_status][0]": "ปกติ",
            "filter[deleted][0]": "1",
            "filter[user_outsider][0]": 0,
            "filter[user_special][0]": 0,
          });
        const response = await FetchAxiosGet("/api/users/datatable",token,params)
        setMergeArray(response?.result);
        setOrgInnerUser(response?.result);
        response.result.map(x => options.push({ value: x.user_id, label: x.user_name }));
        setUsersOptions(options)
        setConditonMessage(false)
      } catch (err) {
        console.error(err);
      }
    };
  
    const fetchOrgGroup = async (orgid, grouparray = null, orgKong = orgInnerKong)=>{ 
      if (orgKong.length > 0) {
        setAllGroup(orgid)
        const orgID = orgKong?.find(item=>(item.org_id === Number(orgid)))
        setOrgInnerUser([])
        if (orgID?.child?.length > 0) {
          fetchUser(orgID?.org_id,"division")
          orgID?.child?.map(x=>(fetchUser(x.org_id,"division")))
        } else {
          if (orgID !== undefined) {fetchUser(orgID?.org_id,"division")}
        }
        if (orgInnerSubGroup.length > 0) {
          const combinedArray = [...orgInnerSubGroup, ...orgID?.child?.filter(x=>x.active === 1)];
          setOrgInnerGroup(combinedArray)
        } else {
          setOrgInnerGroup(orgID?.child?.filter(x=>x.active === 1))
        }
      } else {
        if (grouparray !== null) {
            grouparray?.map(async (i) => (
             await fetchUser(i.org_id,"group")
            ))
           setOrgInnerGroup(grouparray)
           setCloseWordAll(false)
        }
       
      }
    }

    const checkPosition = async (user_id) => {
      let params = new URLSearchParams({
        page: 1,
        size: 1,
        "order[0]": "user_id",
        "order[1]": "ASC",
        "filter[user_id][0]": user_id,
        "filter[position_id][0]": 2,
        "filter[position_id][1]": 3,
        "filter[position_id][2]": 4,
        "filter[position_id][3]": 5,
      });
      if (checkLeave) {
        params.delete("filter[position_id][3]", 5)
      }
      const res_position = await FetchAxiosGet("/api/users/position/datatable",token,params)
      if (res_position?.result?.length > 0) {
        return false
      } else {
        return user_id
      }
    }

    const fetchUser = async(orgiduser,task)=>{
      let result_after_check_position = [] ;
      const params = new URLSearchParams({
          page: 1,
          size: 400,
          "order[0]": "user_id",
          "order[1]": "ASC",
          "filter[user_name_status][0]": "ปกติ",
          "filter[deleted][0]": "1",
          "filter[cont_to_id][0]": orgiduser,
          "filter[user_outsider][0]": 0,
          "filter[user_special][0]": 0,
        });
      const res = await FetchAxiosGet("/api/users/datatable",token,params)
      
      for await (const y of res?.result) {
        if (await checkPosition(y.user_id)) {
          result_after_check_position.push(y)
        }
      }

      if (task === "division") {
        setOrgInnerUser(prev => [...prev, result_after_check_position]);
      } else if (task === "group") {
        setOrgInnerUser(result_after_check_position);
      }
    }
    
  
    useEffect(() => {
      const letEffect = async ()=>{
       await fetchInfo()
      }
      letEffect()
    }, [])

    useEffect(() => {
     if (userInfo!==null) {
      getOrgInnerKong()
     }
    }, [userInfo])

    useEffect(() => {
      setConditonMessage(true)
      let options;
      if (!notAdAll) {
        options = [{ value: "", label: 'ทั้งหมด' }]
      } else {
        options = []
      }
      const combinedArray = orgInnerUser.reduce((result, currentArray) => result.concat(currentArray), []);
      const uniqueDataArray = Array.from(new Set(combinedArray.map(JSON.stringify))).map(JSON.parse);
      setMergeArray(uniqueDataArray)
      uniqueDataArray?.length > 0 && uniqueDataArray?.map(x => options.push({ value: x.user_id, label: x.user_name }));
      setUsersOptions([{ value: userInfo?.user_id, label: userInfo?.user_name }, ...options])
      
      setConditonMessage(false)
    }, [orgInnerUser])

    useEffect(() => {
      if (orgInnerGroup?.length > 0) {
        if (arrayOrgGroup !== null) {
          arrayOrgGroup(orgInnerGroup)
        }
      }
    }, [orgInnerGroup])

    useEffect(() => {
      if (functionCheck !== undefined) {
        functionCheck(!(mergeArray?.length > 0  || orgInnerKong?.length > 0))
      }
    }, [mergeArray,orgInnerKong,functionCheck])
    
    useEffect(() => {
      // ในกรณีโหลดมาครั้งแรก
      if (mergeArray !== null && needAlluser !== undefined) {
        needAlluser(mergeArray?.sort())
      }
    }, [mergeArray])
    


  return (
    <Row>
      {closeWordAll &&
        <Col xs={sizeXs} md={sizeMd} xl={sizeXl}>
        <FormGroup row>
            <Label className="text-end" xxl={4} xs={4}>
                สำนัก/กอง
            </Label>
            <Col>
                <Input
                    type="select"
                    // invalid = {!orgHasSelected}
                    // disabled={!(mergeArray?.length > 0  || orgInnerKong?.length > 0)}
                    disabled={!(orgInnerKong?.length > 0)}
                    onChange={(e) => {
                       setDivisionOrg(e.target.value)
                       fetchOrgGroup(e.target.value)
                       if (e.target.value === "") {
                        getOrgInnerKong()
                       }
                      //  if (needAlluser){
                      //   console.log(mergeArray?.sort())
                      //   setDivisionOrg(e.target.value, mergeArray?.sort())
                      // }
                      //  setOrgHasSelected(false)
                    }}
                    >
                    {orgInnerKong?.length > 0 ? 
                      <Fragment>
                        {/* {!(orgInnerKong?.length === 1) ? <option value="">ทั้งหมด</option> : <option value="">กรุณาระบุ</option>} */}
                        {!(orgInnerKong?.length === 1) && <option value="">ทั้งหมด</option> }
                        {orgInnerKong?.map((item) => {
                            return (
                                <option key={item?.org_id} value={item?.org_id}>
                                    {item?.org_name}
                                </option>
                            );
                        })}
                      </Fragment>
                    :
                      <option value={null}>กำลังโหลดข้อมูล...</option>
                    }
                </Input>
            </Col>
        </FormGroup>
        </Col>
        }
        <Col xs={sizeXs} md={closeWordAll ? sizeMd : sizeMd == 12 ? sizeMd : 6} xl={closeWordAll ? sizeXl : sizeXl == 12 ? sizeXl : 6}>
        <FormGroup row>
            <Label className="text-end" xxl={4} xs={4}>
                กลุ่ม
            </Label>
            <Col>
                <Input
                  // disabled={closeWordAll}
                  // disabled={!(mergeArray?.length > 0  || orgInnerKong?.length > 0) && closeWordAll}
                  type="select"
                  onChange={(e) => {
                     setGroupOrg(e.target.value)
                     fetchUser(Number(e.target.value),"group")
                     if (allGroup !== "" && e.target.value === allGroup.toString()) {
                      fetchOrgGroup(e.target.value)
                     }
                    //  setOrgHasSelected(false)
                  }}
                >
                    {orgInnerGroup?.length > 0 ? 
                      <Fragment>
                        {/* {closeWordAll ? <option value={allGroup}>ทั้งหมด</option> : <option value="">กรุณาระบุ</option>} */}
                        {closeWordAll && <option value={allGroup}>ทั้งหมด</option> }
                        {orgInnerGroup?.map((item) => {
                            return (
                                <option key={item?.org_id} value={item?.org_id}>
                                    {item?.org_name}
                                </option>
                            );
                        })}
                      </Fragment>
                     :
                      <option value={null}>ทั้งหมด</option> 
                    }
                </Input>
            </Col>
        </FormGroup>
        </Col>
          <Col xs={sizeXs} md={closeWordAll ? sizeMd : sizeMd == 12 ? sizeMd : 6} xl={closeWordAll ? sizeXl : sizeXl == 12 ? sizeXl : 6}>
          <FormGroup row>
              <Label className="text-end" xxl={4} xs={4}>
                  เจ้าหน้าที่
              </Label>
              <Col>
                  {/* <Input
                      // disabled={!(mergeArray?.length > 0)}
                      disabled={!(mergeArray?.length > 0  || orgInnerKong?.length > 0) && closeWordAll}
                      type="select"
                      onChange={(e) => {
                        if (task === "nothin") {
                          setUserOrg(e.target.value)
                        } else {
                          setUserOrg(e.target.value,e.target.options[e.target.selectedIndex].text)
                          console.log(e.target.value,e.target.options[e.target.selectedIndex].text)
                        }
                        
                      }}
                      >
                      {mergeArray?.length > 0 ? 
                        <Fragment>
                          {!notAdAll && <option value="">ทั้งหมด</option>}
                          {mergeArray?.sort()?.map((item) => {
                              return (
                                  <option key={item?.user_id} value={item?.user_id}>
                                      {item?.user_name}
                                  </option>
                              );
                          })}
                        </Fragment>
                      :
                        <option value={null}>กำลังรอข้อมูล...</option>
                      }
                  </Input> */}
                  <Select className="basic-single" classNamePrefix="เจ้าหน้าที่" isSearchable={true} placeholder='เจ้าหน้าที่...' options={usersOptions} 
                      required={requiredCondition}
                      noOptionsMessage={()=>conditonMessage ? "กำลังดาวน์โหลดข้อมูล..." : "ไม่พบรายชื่อเจ้าหน้าที่ดังกล่าว"}
                      // loadingMessage={()=>"กำลังดาวน์โหลดข้อมูล"}
                      defaultValue='0'
                      onChange={e => {  
                        if (task === "nothin") {
                          setUserOrg(e?.value)
                        } else {
                          setUserOrg(e?.value, e?.label)
                        } 
                    }} 
                  />
              </Col>
        </FormGroup>
        </Col>
    </Row>
  )
}

export default SelectOrg
